class DrawerMenu extends HTMLElement {
  static isFrenchWithCHF() {
    // Check for French locale and CHF currency
    const locale = window.Shopify?.locale;
    const currency = window.Shopify?.currency?.active;
    return locale?.startsWith("fr") && currency === "CHF";
  }

  static getMenuData() {
    // Check if French locale and CHF currency
    const isFrenchWithCHF = DrawerMenu.isFrenchWithCHF();

    // Get appropriate menu data
    if (isFrenchWithCHF && window.menu_json_fr) {
      return window.menu_json_fr;
    }

    return window.menu_json;
  }

  connectedCallback() {
    const initializeDrawerMenu = () => {
      // Initialize drawer menu elements
      this.drawer = this.querySelector(".drawer-menu");
      this.templateLevel1 = this.querySelector("#DrawerMenuLevel1");
      this.templateLevel2 = this.querySelector("#DrawerMenuLevel2");

      this.openDrawer();
      this.closeDrawer();

      const rootNavItems = this.querySelectorAll(".drawer-menu-nav-items__item");
      this.addClickListeners(rootNavItems, 1);
    };

    const observer = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      const lastEntry = entries[entries.length - 1]; // Get the latest LCP entry
      if (lastEntry) {
        initializeDrawerMenu();
        observer.disconnect(); // Disconnect observer after LCP is detected
      }
    });

    observer.observe({ type: "largest-contentful-paint", buffered: true });

    // Fallback using requestAnimationFrame with a maximum number of attempts
    let rafAttempts = 0;
    const maxRafAttempts = 60; // Adjust this number based on your needs

    const rafFallback = () => {
      if (!observer.takeRecords().length && rafAttempts < maxRafAttempts) {
        rafAttempts += 1;
        requestAnimationFrame(rafFallback);
      } else if (rafAttempts >= maxRafAttempts) {
        initializeDrawerMenu();
      }
    };

    // Use requestAnimationFrame for a more performant fallback
    requestAnimationFrame(rafFallback);

    // Additional fallback for DOMContentLoaded
    document.addEventListener("DOMContentLoaded", () => {
      if (!observer.takeRecords().length) {
        initializeDrawerMenu();
      }
    });
  }

  openDrawer() {
    const headerDrawerButtons = document.querySelectorAll("header.header .user-links__drawer");
    headerDrawerButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.drawer.classList.add("drawer-menu--show");
        document.body.classList.add("overflow-hidden");
      });
    });
  }

  closeDrawer() {
    const closeDrawerButtons = this.querySelectorAll(".drawer-menu__overlay, .drawer-menu-header__close-button");
    closeDrawerButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.drawer.classList.remove("drawer-menu--show");
        document.body.classList.remove("overflow-hidden");
      });
    });
  }

  addClickListeners(navItems, level, parentIndex = null) {
    navItems.forEach((item, index) => {
      item.addEventListener("click", (e) => {
        if (
          e.target.classList.contains("drawer-menu-navigation-footer__link") ||
          e.target.closest(".drawer-menu-navigation-footer__link")
        ) {
          const link = e.target.contains("drawer-menu-navigation-footer__link")
            ? e.target.href
            : e.target.closest(".drawer-menu-navigation-footer__link").href;
          window.location = link;
        }
        if (
          e.target.classList.contains("drawer-menu-cards-navigation__item") ||
          e.target.closest(".drawer-menu-cards-navigation__item")
        ) {
          try {
            const element = e.target.classList.contains("drawer-menu-cards-navigation__item")
              ? e.target
              : e.target.closest(".drawer-menu-card-navigation");

            if (!element) {
              throw new Error("Could not find drawer menu cards navigation item element");
            }

            const link = element.href;
            if (!link) {
              throw new Error("Drawer menu cards navigation item is missing href");
            }

            window.location = link;
          } catch (error) {
            console.error("Error navigating drawer menu cards:", error);
          }
        }
        if (!item.querySelector("svg")) {
          window.location = item.querySelector("a").href;
        } else if (!item.querySelector(`.drawer-menu-level-${level}`)) {
          e.preventDefault();
          if (level === 1) {
            this.injectSubmenuLevel1(item, index);
          } else if (level === 2) {
            this.injectSubmenuLevel2(item, parentIndex, index);
          }
        } else if (item.querySelector(`.drawer-menu-level-${level}`)) {
          e.preventDefault();
          item.querySelector(`.drawer-menu-level-${level}`).style.setProperty("--show-submenu", "flex");
        }

          // Level 3 mobile - using event delegation
        document.querySelector("drawer-menu").addEventListener('click', (e) => {
          const anchor = e.target.closest('.drawer-menu-card-navigation');
          if (anchor) {
            window.dataLayer.push({
              event: 'select_navitem_dev',
              nav_level: "3",
              nav_type: "main-navigation",
              category_name: anchor.textContent?.trim(),
              category_id: anchor.textContent?.trim()
            });
          }
        });
  });
    });
  }

  injectSubmenuLevel1(item, index) {
    // Fetch data dynamically for the hovered item
    const menuData = DrawerMenu.getMenuData().menuItems[index];
    if (!menuData) return;

    // Clone the template
    const templateContent = this.templateLevel1.content.cloneNode(true);

    // Update template content
    const titleElement = templateContent.querySelector(".drawer-menu-navigation-header h3");
    const navList = templateContent.querySelector(".drawer-menu-nav-items");
    const footerLink = templateContent.querySelector(".drawer-menu-navigation-footer__link");
    const backButton = templateContent.querySelector(".drawer-menu-navigation-header__back-button");
    const closeButton = templateContent.querySelector(".drawer-menu-header__close-button");
    const submenu = templateContent.querySelector(".drawer-menu-level-1");
    submenu.style.setProperty("--show-submenu", "flex");

    backButton.addEventListener("click", (e) => {
      e.stopPropagation();
      submenu.style.setProperty("--show-submenu", "none");
    });

    closeButton.addEventListener("click", () => {
      this.drawer.classList.remove("drawer-menu--show");
      document.body.classList.remove("overflow-hidden");
    });

    // Update title and sub-menu items
    titleElement.textContent = menuData.title;
    navList.innerHTML = ""; // Clear existing items

    // Add sub-menu items
    menuData.subMenu.forEach((subItem) => {
      const listItem = document.createElement("li");
      listItem.className = "drawer-menu-nav-items__item";
      listItem.innerHTML = `
          <a href="${subItem.url}" class="drawer-menu-item">
            ${subItem.image && !subItem.image.includes("error") ? `<div class="image"><img src="${subItem.image}" class="image__img image--contain"></div>` : "<div class='drawer-menu__image-placeholder'></div>"}
            <p class="text text--sm text--regular text--line-height-sm text--body-font text--none-decoration" style="--text-color: var(--color--secondary);">
              ${subItem.title}
            </p>
            ${
              subItem.subMenu && subItem.subMenu.length > 0
                ? `
              <svg width="40" height="40" aria-hidden="false" aria-label="open menu" class="icon" style="--icon-fill: none; --icon-stroke: var(--color--secondary);">
                <use xlink:href="#icon-menu-drawer-next"></use>
              </svg>
            `
                : ""
            }
          </a>
        `;
      navList.appendChild(listItem);
    });

    // Update footer link
    footerLink.href = menuData.url;
    const seeMenuText = this.getAttribute("see-menu-text").replace("[menu]", menuData.title);
    footerLink.querySelector("span").textContent = `${seeMenuText}`;

    // Inject the updated template into the hovered item
    item.appendChild(templateContent);

    // Trigger Level 2 submenus after Level 1 is injected
    this.addClickListeners(item.querySelectorAll(".drawer-menu-nav-items__item"), 2, index);
  }

  injectSubmenuLevel2(item, level1Index, level2Index) {
    // Find the corresponding Level 2 menu data based on Level 1 item index and Level 2 submenu index
    const menuData = DrawerMenu.getMenuData().menuItems[level1Index].subMenu[level2Index];
    if (!menuData) return;

    const templateContent = this.templateLevel2.content.cloneNode(true);
    const titleElement = templateContent.querySelector(".drawer-menu-navigation-header h3");
    const navList = templateContent.querySelector(".drawer-menu-cards-navigation__list");
    const backButton = templateContent.querySelector(".drawer-menu-navigation-header__back-button");
    const footerLink = templateContent.querySelector(".drawer-menu-navigation-footer__link");
    const closeButton = templateContent.querySelector(".drawer-menu-header__close-button");

    closeButton.addEventListener("click", () => {
      this.drawer.classList.remove("drawer-menu--show");
      document.body.classList.remove("overflow-hidden");
    });

    backButton.addEventListener("click", (e) => {
      e.stopPropagation();
      item.querySelector(".drawer-menu-level-2").style.setProperty("--show-submenu", "none");
    });

    titleElement.textContent = menuData.title;
    navList.innerHTML = "";

    menuData.subMenu.forEach((subItem) => {
      const listItem = document.createElement("li");
      listItem.className = "drawer-menu-cards-navigation__item";
      listItem.innerHTML = `
          <a href="${subItem.url}" class="drawer-menu-card-navigation">
            ${subItem.image && !subItem.image.includes("error") ? `<div class="image"><img src="${subItem.image}" class="image__img image--contain"></div>` : "<div class='drawer-menu__image-placeholder'></div>"}
            <p class="text text--x-sm text--regular text--line-height-sm text--body-font text--none-decoration" style="--text-color: var(--color--secondary);">${subItem.title}</p>
          </a>
        `;
      navList.appendChild(listItem);
    });
    // Update footer link
    footerLink.href = menuData.url;
    const seeMenuText = this.getAttribute("see-menu-text").replace("[menu]", menuData.title);
    footerLink.querySelector("span").textContent = `${seeMenuText}`;

    item.appendChild(templateContent);
  }
}

customElements.define("drawer-menu", DrawerMenu);
